<div class="padding-all public-note">
    <div class="notes">
        <div class="note-header default-font padding-bottom">
            <strong>{{note.createdByUserName}}</strong>
            <span class="float-right">{{note.dateCreated | date: 'MM/dd/yyyy | hh:mm a'}}</span>
        </div>
        <div [innerHTML]="note.comment">
        </div>
    </div>
</div>